var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWinkPowered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 22,
    viewBox: "0 0 52 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 22,
    fill: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8184 13.1348L38.1708 12.621L40.7265 15.9315H42.9127V15.779L39.2718 11.0502L42.8218 6H40.598L37.8184 9.94912V6H36.0127V15.9315H37.8184V13.1348Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6427 10.463L33.9566 15.9315H33.9571V6H32.1514V11.4759L26.8369 6.03223V15.9315H28.6427V10.463Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.84 6H23.0049V15.9315H24.84V6Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4911 6H20.5819L18.4838 11.4466L15.7091 6L12.9198 11.4466L10.8963 6H9V6.0379L12.6665 15.8669L15.6944 9.91977L18.7633 15.8826L22.4911 6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinkPowered);
export default __webpack_public_path__ + "static/media/wink-powered.2e13d2acabb3581ab4d650e1d1f8190f.svg";
export { ForwardRef as ReactComponent };